module.exports = __webpack_public_path__ + "img/Anna_S.191cf035.png";